//////////////////////////////////
//Auto-generated. Do NOT modify!//
//////////////////////////////////

import { MessageKey, QueryKey, Type, EnumType, registerSymbol } from '../../../Framework/Signum.React/Scripts/Reflection'
import * as Entities from '../../../Framework/Signum.React/Scripts/Signum.Entities'
import * as Basics from '../../../Framework/Signum.React/Scripts/Signum.Entities.Basics'
import * as Mailing from '../../../Extensions/Signum.React.Extensions/Mailing/Signum.Entities.Mailing'
import * as SMS from '../../../Extensions/Signum.React.Extensions/SMS/Signum.Entities.SMS'
import * as Workflow from '../../../Extensions/Signum.React.Extensions/Workflow/Signum.Entities.Workflow'
import * as Authorization from '../../../Extensions/Signum.React.Extensions/Authorization/Signum.Entities.Authorization'
import * as Files from '../../../Extensions/Signum.React.Extensions/Files/Signum.Entities.Files'
import * as Signum from '../../../Extensions/Signum.React.Extensions/Basics/Signum.Entities.Basics'
import * as Scheduler from '../../../Extensions/Signum.React.Extensions/Scheduler/Signum.Entities.Scheduler'
import * as TrustedApi from '../../../Saturn/Saturn.React/TrustedApi/Saturn.Entities.TrustedApi'


export const ApplicationConfigurationEntity = new Type<ApplicationConfigurationEntity>("ApplicationConfiguration");
export interface ApplicationConfigurationEntity extends Entities.Entity {
  Type: "ApplicationConfiguration";
  environment: string;
  databaseName: string;
  email: Mailing.EmailConfigurationEmbedded;
  sMS: SMS.SMSConfigurationEmbedded;
  workflow: Workflow.WorkflowConfigurationEmbedded;
  activeDirectoryAuthorizer: Authorization.ActiveDirectoryConfigurationEmbedded;
  trustedApiClient: TrustedApi.TrustedApiConfigurationEmbedded;
  emailSender: Mailing.EmailSenderConfigurationEntity;
  authTokens: Authorization.AuthTokenConfigurationEmbedded;
  garbageLogs: Basics.DeleteLogParametersEmbedded;
  createUserRole: Entities.Lite<Authorization.RoleEntity> | null;
  showLicenseInfo: boolean;
  logos: LogosEmbedded;
  throwMissingFormulasException: boolean;
}

export module ApplicationConfigurationOperation {
  export const Save : Entities.ExecuteSymbol<ApplicationConfigurationEntity> = registerSymbol("Operation", "ApplicationConfigurationOperation.Save");
}

export module FarazMessage {
  export const DefaultValue = new MessageKey("FarazMessage", "DefaultValue");
  export const _0IsSystemic = new MessageKey("FarazMessage", "_0IsSystemic");
  export const ThePasswordMustHaveAtLeast8CharactersOneDigitOneUppercaseAndOneLowercaseIncluded = new MessageKey("FarazMessage", "ThePasswordMustHaveAtLeast8CharactersOneDigitOneUppercaseAndOneLowercaseIncluded");
  export const General = new MessageKey("FarazMessage", "General");
}

export module FarazPermission {
  export const ChangeSystemicWordTemplate : Authorization.PermissionSymbol = registerSymbol("Permission", "FarazPermission.ChangeSystemicWordTemplate");
  export const OpenInboxAsMainPage : Authorization.PermissionSymbol = registerSymbol("Permission", "FarazPermission.OpenInboxAsMainPage");
}

export module FarazTask {
  export const DeleteLogs : Scheduler.SimpleTaskSymbol = registerSymbol("SimpleTask", "FarazTask.DeleteLogs");
}

export module FarazTypeCondition {
  export const UserEntities : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.UserEntities");
  export const RoleEntities : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.RoleEntities");
  export const UserRoleGroupEntities : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.UserRoleGroupEntities");
  export const CurrentCustomer : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.CurrentCustomer");
  export const SystemicEntities : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.SystemicEntities");
  export const RecipientEntities : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.RecipientEntities");
  export const DoneByEntities : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.DoneByEntities");
  export const CreatedByEntities : Signum.TypeConditionSymbol = registerSymbol("TypeCondition", "FarazTypeCondition.CreatedByEntities");
}

export const IsSystemicMixin = new Type<IsSystemicMixin>("IsSystemicMixin");
export interface IsSystemicMixin extends Entities.MixinEntity {
  Type: "IsSystemicMixin";
  isSystemic: boolean;
}

export module LicenseMessage {
  export const Module0IsNotLicensed = new MessageKey("LicenseMessage", "Module0IsNotLicensed");
  export const YourConfigurationAllowsForOnly0ActiveUsersButYouHave1 = new MessageKey("LicenseMessage", "YourConfigurationAllowsForOnly0ActiveUsersButYouHave1");
}

export const LogosEmbedded = new Type<LogosEmbedded>("LogosEmbedded");
export interface LogosEmbedded extends Entities.EmbeddedEntity {
  Type: "LogosEmbedded";
  smallLogo: Files.FileEmbedded | null;
  bigLogo: Files.FileEmbedded | null;
}


